import * as styled from "./Offerta.styled";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle.jsx";

function Offerta({ isStudent }) {
  return (
    <styled.Wrapper>
      <TopPageTitle value="Договір оферти" />
      <styled.Document>
      {isStudent ? (
        <>
          <styled.Title>ДОГОВІР ПУБЛІЧНОЇ ОФЕРТИ</styled.Title>
          <styled.Subtitle>на надання освітніх послуг</styled.Subtitle>
          <styled.Paragraph>
            Цей Договір є публічною офертою фізичної особи-підприємця Гробового
            В’ячеслава Максимовича, зареєстрованого відповідно до законодавства
            України (надалі — «Виконавець»), і має юридичну силу відповідно до
            ст. 633, 641 Цивільного кодексу України.
          </styled.Paragraph>

          <styled.SectionTitle>1. ВИЗНАЧЕННЯ ТЕРМІНІВ</styled.SectionTitle>
          <styled.List>
            <li>
              <b>1.1. Виконавець</b> — фізична особа-підприємець, яка
              організовує та забезпечує надання освітніх послуг відповідно до
              цього Договору.
            </li>
            <li>
              <b>1.2. Замовник</b> — фізична особа, яка приймає умови цього
              Договору та здійснює оплату освітніх послуг. У випадку, якщо
              Замовником виступає неповнолітня особа, акцепт цього Договору
              здійснюється її законним представником (батьком, матір’ю або
              опікуном), який несе повну відповідальність за дотримання умов
              цього Договору.
            </li>
            <li>
              <b>1.3. Освітні послуги</b> — онлайн-уроки іноземних мов (англійської, іспанської),
              доступ до навчальних матеріалів, консультацій, супроводу тощо
              через освітню платформу Виконавця.
            </li>
            <li>
              <b>1.4. Платформа</b> — веб-ресурс, що забезпечує організацію та
              проведення уроків, перегляд розкладу, матеріалів, звітів тощо.
            </li>
            <li>
              <b>1.5. Урок</b> — онлайн-заняття з іноземної мови, проведене
              через відеозв’язок (наприклад, Google Meet).
            </li>
            <li>
              <b>1.6. Пакет уроків</b> — заздалегідь визначена кількість уроків,
              що надається Замовнику після оплати. Невикористані уроки
              зберігаються на балансі на умовах розділу 7.
            </li>
            <li>
              <b>1.7. Навчальні матеріали школи</b> — усі текстові, графічні,
              аудіо- та відеоматеріали, надані Виконавцем у процесі навчання.
            </li>
          </styled.List>

          <styled.SectionTitle>2. ЗАГАЛЬНІ ПОЛОЖЕННЯ</styled.SectionTitle>
          <styled.List>
            <li>
              2.1. Цей Договір регулює правовідносини між Виконавцем та
              Замовником щодо надання та отримання освітніх послуг.
            </li>
            <li>
              2.2. Договір є публічним, укладається шляхом акцепту цієї оферти
              та є обов’язковим для виконання.
            </li>
            <li>
              2.3. Реєстрація Замовника на платформі здійснюється
              адміністратором. Користування платформою означає повне погодження
              з цим Договором та Правилами школи.
            </li>
          </styled.List>

          <styled.SectionTitle>3. ПРЕДМЕТ ДОГОВОРУ</styled.SectionTitle>
          <styled.List>
            <li>
              3.1. Виконавець зобов’язується організувати та надати Замовнику
              освітні послуги з вивчення іноземних мов в онлайн-форматі.
            </li>
            <li>
              3.2. Послуги надаються через платформу Виконавця з використанням
              сервісу відеозв’язку Google Meet.
            </li>
            <li>
              3.3. Тривалість уроку: для учнів до 12 років — 45 хвилин, від 12
              років — 50 хвилин.
            </li>
            <li>
              3.4. Запізнення Замовника на урок не компенсується: урок
              завершується в час, визначений розкладом.
            </li>
          </styled.List>

          <styled.SectionTitle>
            4. ПРАВА ТА ОБОВ’ЯЗКИ СТОРІН
          </styled.SectionTitle>
          <styled.Paragraph>
            <b>4.1. Виконавець зобов’язаний:</b>
          </styled.Paragraph>
          <styled.List>
            <li>Надати доступ до платформи після оплати пакета.</li>
            <li>Організувати проведення уроків.</li>
            <li>Забезпечити актуальний розклад та матеріали.</li>
            <li>Забезпечити конфіденційність персональних даних Замовника.</li>
            <li>
              У разі припинення співпраці з викладачем — знайти Замовнику нового
              викладача без зобов’язань щодо часу пошуку та графіку майбутніх
              уроків.
            </li>
            <li>
              На прохання Замовника — замінити викладача на іншого.
            </li>
            <li>
              Якщо урок не відбувся з вини викладача — перенести його на інший
              зручний для Замовника час без списання з балансу.
            </li>
          </styled.List>

          <styled.Paragraph>
            <b>4.2. Замовник зобов’язаний:</b>
          </styled.Paragraph>
          <styled.List>
            <li>Своєчасно оплачувати послуги.</li>
            <li>Приєднуватися до уроків згідно з розкладом.</li>
            <li>
              Повідомляти про скасування уроку не пізніше ніж за 4 години до
              початку.
            </li>
            <li>
              Дотримуватися умов цього Договору та Правил школи, опублікованих
              на платформі Виконавця.
            </li>
            <li>
              Не поширювати та не передавати третім особам навчальні матеріали
              школи Speaksy без письмової згоди Виконавця.
            </li>
          </styled.List>

          <styled.SectionTitle>
            5. ПОРЯДОК УКЛАДЕННЯ ДОГОВОРУ
          </styled.SectionTitle>
          <styled.List>
            <li>
              5.1. Договір вважається укладеним з моменту акцепту (оплати
              Замовником освітніх послуг та/або користуванням функціоналом
              платформи)
            </li>
            <li>5.2. За бажанням Замовника пакет можна змінити.</li>
          </styled.List>

          <styled.SectionTitle>
            6. ВАРТІСТЬ ТА ПОРЯДОК ОПЛАТИ
          </styled.SectionTitle>
          <styled.List>
            <li>
              6.1. Актуальна вартість пакетів уроків зазначена на сайті
              Виконавця та в кабінеті Замовника на платформі. Ціна фіксується на
              момент оплати; акційні умови діють лише у строк, зазначений в
              акції.
            </li>
            <li>
              6.2. Оплата здійснюється на рахунок Виконавця за реквізитами,
              вказаними на сайті, у повідомленні адміністратора або через
              інтегровану платіжну систему на платформі.
            </li>
          </styled.List>

          <styled.SectionTitle>
            7. СКАСУВАННЯ, ПЕРЕНЕСЕННЯ І ПОВЕРНЕННЯ
          </styled.SectionTitle>
          <styled.List>
            <li>
              7.1. Урок можна скасувати або перенести не пізніше ніж за 4 години
              до початку.
            </li>
            <li>
              7.2. У разі скасування менше ніж за 4 години — урок вважається
              проведеним та списується з балансу учня.
            </li>
            <li>
              7.3. У разі форс-мажорних обставин (відсутність електроенергії,
              стихійні лиха) урок може бути перенесений без втрати.
            </li>
            <li>
              7.4. У разі, якщо Замовник бажає припинити навчання до повного
              використання придбаного пакета уроків, кошти за невикористані
              уроки не повертаються. Проте Замовник має право поставити навчання
              на паузу.
            </li>
            <li>
              7.5. Відновити навчання після паузи Замовник може в будь-який час;
              невикористані уроки зберігаються на балансі.
            </li>
            <li>
              7.6. Під час паузи Виконавець не гарантує, що за Замовником
              збережуться той самий викладач і час уроків. Після паузи Виконавець
              гарантує Замовнику викладача — того самого, якщо він має вільний
              час, або нового.
            </li>
          </styled.List>

          <styled.SectionTitle>8. СТРОК ДІЇ ДОГОВОРУ</styled.SectionTitle>
          <styled.List>
            <li>
              8.1. Договір діє з моменту акцепту та до повного виконання
              сторонами зобов’язань.
            </li>
            <li>
              8.2. Виконавець залишає за собою право вносити зміни до цього
              Договору, публікуючи оновлену версію на платформі.
            </li>
          </styled.List>

          <styled.SectionTitle>9. ВІДПОВІДАЛЬНІСТЬ СТОРІН</styled.SectionTitle>
          <styled.Paragraph>
            У разі невиконання або неналежного виконання зобов’язань, винна
            сторона несе відповідальність згідно з чинним законодавством
            України.
          </styled.Paragraph>

          <styled.SectionTitle>
            10. БОНУСНА ПРОГРАМА
          </styled.SectionTitle>
          <styled.List>
            <li>
              10.1. Виконавець може нараховувати Замовнику бонусні бали
              («зірки») — за виконані домашні завдання, підключення
              Telegram-бота школи, участь в акціях тощо.
            </li>
            <li>
              10.2. Зірки не є грошовими коштами: їх не можна обміняти на гроші,
              повернути чи передати іншій особі. Зірки обмінюються лише на
              винагороди в магазині на платформі.
            </li>
            <li>
              10.3. «Приведи друга»: якщо друг за посиланням Замовника оплатить
              перший пакет уроків, Замовник і друг отримують по 2 безкоштовні
              уроки.
            </li>
            <li>
              10.4. Виконавець має право змінювати умови бонусної програми, а
              також анулювати зірки й бонуси, отримані з порушенням правил
              (зловживання, фіктивні акаунти тощо).
            </li>
          </styled.List>

          <styled.SectionTitle>
            11. КОНФІДЕНЦІЙНІСТЬ ТА ПЕРСОНАЛЬНІ ДАНІ
          </styled.SectionTitle>
          <styled.List>
            <li>
              11.1. Замовник надає згоду на обробку персональних даних
              відповідно до Закону України «Про захист персональних даних».
            </li>
            <li>
              11.2. Обробка даних здійснюється з метою належного виконання
              Договору.
            </li>
            <li>
              11.3. Усі навчальні матеріали школи Speaksy є інтелектуальною
              власністю Виконавця. Їх розповсюдження, копіювання або передача
              третім особам без дозволу заборонені.
            </li>
          </styled.List>

          <styled.SectionTitle>12. ІНШІ УМОВИ</styled.SectionTitle>
          <styled.List>
            <li>
              12.1. Договір є публічним і постійно доступний на сайті та
              платформі Виконавця.
            </li>
            <li>
              12.2. Всі спірні питання вирішуються шляхом переговорів, а у
              випадку недосягнення згоди — в судовому порядку за законодавством
              України.
            </li>
            <li>
              12.3. Використання платформи Замовником після реєстрації
              вважається підтвердженням того, що він ознайомлений з умовами
              цього Договору та Правилами школи, навіть якщо фактично не
              відкривав або не читав їх. Замовник не має права посилатися на їх
              необізнаність.
            </li>
          </styled.List>

          <styled.SectionTitle>13. РЕКВІЗИТИ ВИКОНАВЦЯ</styled.SectionTitle>
          <styled.Paragraph>
            <b>ФОП Гробовий В’ячеслав Максимович</b>
            <br />
            м. Суми, Україна
            <br />
            IBAN: UA353220010000026003350119405
            <br />
            ЄДРПОУ: 3798103734
            <br />
            Email: info.speaksy@gmail.com
          </styled.Paragraph>
        </>
      ) : (
        <>
          <styled.Title>ДОГОВІР ПУБЛІЧНОЇ ОФЕРТИ</styled.Title>
          <styled.Subtitle>
            на проведення онлайн-занять
          </styled.Subtitle>
          <styled.Paragraph>
            Цей Договір є публічною офертою фізичної особи-підприємця Гробового
            В’ячеслава Максимовича, зареєстрованого відповідно до законодавства
            України (надалі — «Компанія»), та викладачем (надалі — «Виконавець»
            / «Викладач»). Прийнявши умови цього Договору, Виконавець бере на
            себе обов’язок проводити заняття з учнями відповідно до правил,
            встановлених Компанією.
          </styled.Paragraph>

          <styled.SectionTitle>1. ВИЗНАЧЕННЯ ТЕРМІНІВ</styled.SectionTitle>
          <styled.List>
            <li>
              <b>1.1. Урок</b> — онлайн-заняття, проведене Виконавцем із Учнем.
            </li>
            <li>
              <b>1.2. Учень</b> — фізична особа, що отримує освітні послуги за
              договором із Компанією.
            </li>
            <li>
              <b>1.3. Платформа</b> — вебсайт, внутрішня система чи зовнішній
              сервіс для проведення онлайн-занять, наданий Компанією.
            </li>
            <li>
              <b>1.4. Робочий час</b> — період, у який Виконавець зобов’язаний
              бути доступним для зв’язку з Компанією та проведення занять.
            </li>
            <li>
              <b>1.5. Виплата</b> — грошова компенсація Виконавцю за фактично
              проведені та прийняті Компанією уроки.
            </li>
            <li>
              <b>1.6. Менеджер</b> — представник Компанії, який здійснює організаційну 
              комунікацію з Виконавцем (зокрема через Telegram), надає інформацію щодо 
              розкладу, учнів, правил та інших робочих питань.
            </li>
          </styled.List>
          <styled.SectionTitle>2. ЗАГАЛЬНІ ПОЛОЖЕННЯ</styled.SectionTitle>
          <styled.List>
            <li>
              2.1. Договір є публічним, укладається шляхом акцепту цієї оферти та є обов’язковим для виконання.
            </li>
            <li>
              2.2. Отримання Виконавцем учня на платформі та користування платформою означає повне погодження з цим Договором та Правилами школи.
            </li>
          </styled.List>
          <styled.SectionTitle>3. ПРЕДМЕТ ДОГОВОРУ</styled.SectionTitle>
          <styled.List>
            <li>
              3.1. Компанія надає Виконавцю можливість проводити онлайн-уроки з
              учнями.
            </li>
            <li>
              3.2. Виконавець зобов’язується проводити уроки професійно,
              відповідально та згідно з цим Договором.
            </li>
            <li>
              3.3. Усі заняття проводяться у визначеному форматі онлайн, через
              Платформи, які надає Компанія.
            </li>
          </styled.List>

          <styled.SectionTitle>
            4. ПРАВА ТА ОБОВ’ЯЗКИ СТОРІН
          </styled.SectionTitle>
          <styled.Paragraph>
            <b>4.1. Компанія зобов’язана:</b>
          </styled.Paragraph>
          <styled.List>
            <li>Надати доступ до Платформи та навчальних матеріалів.</li>
            <li>Організувати проведення уроків.</li>
            <li>Забезпечити конфіденційність персональних даних Виконавця.</li>
            <li>Здійснювати виплати двічі на місяць — 1-го та 15-го числа.</li>
          </styled.List>

          <styled.Paragraph>
            <b>4.2. Виконавець зобов’язаний:</b>
          </styled.Paragraph>
          <styled.List>
            <li>
              <u>Підготовка до занять:</u> перевіряти інтернет та обладнання
              мінімум за 15 хв до початку; мати робоче місце у тихому
              приміщенні; не проводити уроки у транспорті, на вулиці чи у
              громадських місцях.
            </li>
            <li>
              <u>Якість проведення уроку:</u> вмикати камеру та мікрофон;
              тримати камеру на рівні очей, забезпечити належне освітлення;
              користуватися гарнітурою; не вживати їжу під час заняття.
            </li>
            <li>
              <u>Поведінка та комунікація:</u> бути ввічливим, доброзичливим; не
              використовувати ненормативну лексику; дотримуватися етичних норм
              спілкування з учнями та колегами.
            </li>
            <li>
              <u>Робочий процес:</u> дотримуватися графіку та правил відміни
              уроків; заповнювати відмітку про урок не пізніше ніж через 24
              години; перевіряти домашні завдання учнів протягом 2 днів після
              здачі; повідомляти менеджера про відсутність учня чи технічні
              проблеми; бути на зв’язку у робочий час через Telegram.
            </li>
            <li>
              <u>Репутація та добросовісність:</u> не домовлятися з учнями
              напряму про заняття поза платформою; не передавати учням особисті
              контакти без узгодження з менеджером; порушення цих умов є підставою для негайного розірвання
              Договору та фінансових санкцій.
            </li>
          </styled.List>

          <styled.SectionTitle>5. ОПЛАТА</styled.SectionTitle>
          <styled.List>
            <li>
              5.1. Оплата здійснюється у формі виплат за фактично проведені
              уроки.
            </li>
            <li>
              5.2. Якщо урок не проведено з вини Виконавця, він може не
              оплачуватися або підлягати штрафу.
            </li>
            <li>
              5.3. Якщо учень не приєднався на урок без попереднього скасування або Виконавець не був проінформований про скасування уроку,
              Компанія оплачує Виконавцю повну вартість уроку.
            </li>
            <li>
              5.4. Виплати здійснюються двічі на місяць — 1-го та 15-го числа — за
              уроки, відмічені на платформі. Нараховані суми видно в кабінеті, у
              розділі «Фінанси».
            </li>
          </styled.List>

          <styled.SectionTitle>6. СИСТЕМА ШТРАФІВ</styled.SectionTitle>
          <styled.List>
            <li>
              Неявка на урок без попередження менеджера — штраф 150 грн або попередження;
             Компанія повинна надати учню безкоштовний урок.
            </li>
            <li>
              Відміна уроку у день його проведення (після 21:00 попереднього
              дня) — штраф 75 грн або попередження.
            </li>
            <li>
              Якщо учень не приєднався протягом 5 хвилин від початку уроку, Виконавець повинен повідомити менеджера і не виходити з уроку до його відповіді. На пробному уроці Виконавець повідомляє менеджера і може завершити урок через 15 хвилин від початку, якщо учень так і не приєднався. Неповідомлення менеджера про відсутність учня чи технічні проблеми
              — урок не оплачується.
            </li>
            <li>
             Якщо Виконавець повідомляє про бажання розірвати Договір менш ніж за 14 днів, Компанія не оплачує уроки, проведені з моменту попередньої виплати. Якщо причиною є хвороба та надано підтверджуючі документи (лікарняний, довідка тощо), штрафи не застосовуються.
            </li>
            <li>
              Ігнорування повідомлень у Telegram понад 2 дні — штраф 125 грн або
              попередження. При систематичному ігноруванні Компанія може
              розірвати Договір.
            </li>
          </styled.List>
          

          <styled.SectionTitle>7. ТЕХНІЧНІ ВИМОГИ</styled.SectionTitle>
          <styled.List>
            <li>Комп’ютер або ноутбук.</li>
            <li>Вебкамера.</li>
            <li>Гарнітура (навушники + мікрофон).</li>
            <li>Стабільне інтернет-з’єднання.</li>
            <li>Резервний канал зв’язку (мобільний інтернет).</li>
          </styled.List>

          <styled.SectionTitle>8. ВІДПУСТКА ТА ЛІКАРНЯНІ</styled.SectionTitle>
          <styled.List>
            <li>Виконавець має право на відпустку за умови повідомлення менеджера не пізніше ніж за 14 календарних днів.</li>
            <li>
              У разі хвороби Виконавець зобов’язаний повідомити менеджера та надати підтвердження протягом 5 днів (довідка, лікарняний, інші документи).
            </li>
            <li>За підтвердженого лікарняного штрафи не застосовуються.</li>
          </styled.List>

          <styled.SectionTitle>9. ВІДПОВІДАЛЬНІСТЬ СТОРІН</styled.SectionTitle>
          <styled.List>
            <li>Виконавець відповідає за якість та своєчасність уроків.</li>
            <li>
              Компанія відповідає за організацію процесу та своєчасні виплати.
            </li>
            <li>Спірні питання вирішуються шляхом переговорів.</li>
          </styled.List>

          <styled.SectionTitle>
            10. ПРАВО КОМПАНІЇ ЗМІНЮВАТИ УМОВИ
          </styled.SectionTitle>
          <styled.Paragraph>
            Компанія має право вносити зміни до правил, технічних вимог, штрафів
            та інших положень цього Договору.
          </styled.Paragraph>

          <styled.SectionTitle>
            11. ОБСТАВИНИ НЕПЕРЕБОРНОЇ СИЛИ
          </styled.SectionTitle>
          <styled.Paragraph>
            Сторони звільняються від відповідальності у випадку настання
            форс-мажорних обставин (стихійні лиха, війна, пандемія).
          </styled.Paragraph>

          <styled.SectionTitle>12. ВИРІШЕННЯ СПОРІВ</styled.SectionTitle>
          <styled.Paragraph>
            Усі спори та розбіжності сторони вирішують шляхом переговорів, а за
            відсутності згоди — у судовому порядку відповідно до законодавства
            України.
          </styled.Paragraph>

          <styled.SectionTitle>
            13. ЕЛЕКТРОННА ФОРМА ДОГОВОРУ
          </styled.SectionTitle>
          <styled.Paragraph>
            Цей Договір укладено в електронній формі та має юридичну силу
            відповідно до ст. 205 та ст. 633 Цивільного кодексу України.
            Приймаючи умови, Виконавець підтверджує згоду з усіма положеннями
            цього Договору.
          </styled.Paragraph>
        </>
      )}
      </styled.Document>
    </styled.Wrapper>
  );
}

export default Offerta;
